import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Typography } from '@fupa/fupa-uikit';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import { sponsoringPartnerByDistrict } from 'app/components/partner/SiteSponsoringByDistrict';
import { sponsoringPartnerByRegion } from 'app/components/partner/SiteSponsoringByRegion';
import { SponsorContainer, SponsorImageContainer } from 'app/components/partner/SiteSponsoringRotationAnimation';
const logoWidth = 90;
const logoHeight = 34;
const Logo = styled.img.withConfig({
  componentId: "sc-1ql518l-0"
})(["align-self:center;max-width:", "rem;max-height:", "rem;width:100%;height:100%;"], logoWidth / 16, logoHeight / 16);
const Sponsor = styled.div.withConfig({
  componentId: "sc-1ql518l-1"
})(["display:flex;flex-wrap:nowrap;align-items:center;justify-content:flex-end;gap:0.25rem;"]);
const SCTypography = styled(Typography).withConfig({
  componentId: "sc-1ql518l-2"
})(["&&&{align-self:flex-end;font-style:italic;}"]);
const SiteSponsoring = _ref => {
  let {
    className,
    withClaim
  } = _ref;
  const {
    hasSponsoring,
    partnerList
  } = useSiteSponsoring();
  if (!hasSponsoring) {
    return null;
  }
  const countBrandings = partnerList === null || partnerList === void 0 ? void 0 : partnerList.length;
  const SponsorLogo = partnerList === null || partnerList === void 0 ? void 0 : partnerList.map((partner, index) => {
    return /*#__PURE__*/React.createElement(SponsorImageContainer, {
      key: index,
      justify: partner.justify
    }, /*#__PURE__*/React.createElement("a", {
      "data-google-interstitial": "false",
      target: "_blank",
      href: partner.link,
      rel: "nofollow"
    }, /*#__PURE__*/React.createElement(Logo, {
      src: partner.imgPath,
      width: "auto",
      height: "auto",
      alt: partner.sponsor
    })));
  });
  if (withClaim) {
    return /*#__PURE__*/React.createElement(Sponsor, null, /*#__PURE__*/React.createElement(SCTypography, {
      variant: "caption1"
    }, "pr\xE4sentiert von"), /*#__PURE__*/React.createElement(SponsorContainer, {
      countBrandings: countBrandings
    }, SponsorLogo));
  } else {
    return /*#__PURE__*/React.createElement(SponsorContainer, {
      className: className,
      countBrandings: countBrandings
    }, SponsorLogo);
  }
};
const checkSponsoring = district => {
  var _district$region;
  if (!(district !== null && district !== void 0 && district.slug) || !((_district$region = district.region) !== null && _district$region !== void 0 && _district$region.slug)) {
    return {
      hasSponsoring: false,
      partnerList: []
    };
  }
  const partnerList = sponsoringPartnerByDistrict(district.slug) || sponsoringPartnerByRegion(district.region.slug);
  return {
    hasSponsoring: !!partnerList,
    partnerList: partnerList || []
  };
};
const useSiteSponsoring = () => {
  const district = useSelector(reduxSelectDistrict);
  const [sponsoringData, setSponsoringData] = useState(() => checkSponsoring(district));
  useEffect(() => {
    setSponsoringData(checkSponsoring(district));
  }, [district]);
  return sponsoringData;
};
export { SiteSponsoring, useSiteSponsoring };